import { useState } from "react";
import { IMG_URl } from "../../../common/img_url";
import { Trash } from "lucide-react";
import Iterator from "../../utils/Iterator";
import { indexStore } from "../../../store/indexStore";
import Visibility from "../../utils/Visibility";
import { useNavigate, useParams } from "react-router-dom";
import UAEDirhamIcon from "../../utils/UAEDirhamIcon";

const CartItem = ({
  element,
  handleRemoveItem,
  handleUpdateQuantity,
}: {
  element: any;
  handleRemoveItem: (item: any) => void;
  handleUpdateQuantity: (item: any, quantity: number) => void;
}) => {
  const [quantity, setQuantity] = useState(element.amount || 1);
  const { name } = indexStore();
  const calculateTotalPrice = () => {
    let totalPrice = element.price;
    if (element.option) {
      element.option.forEach((opt: any) => {
        if (opt.subOption) {
          totalPrice += opt.subOption.price;
        }
      });
    }
    return totalPrice * quantity;
  };

  // دوال لتحديث الكمية
  const handleIncrement = () => {
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    handleUpdateQuantity(element, newQuantity);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      handleUpdateQuantity(element, newQuantity);
    }
  };
  const renderOptions = (e: any, i: number) => {
    return (
      <div key={i} className="text-xs md:text-sm text-muted-foreground">
        <span className="font-semibold text-foreground">{e.option[name]}:</span>
        <span className="ml-1">{e.subOption[name]}</span>
        <Visibility visible={e.subOption.price > 0}>
          <span dir="ltr" className="flex items-center gap-1 ml-1 text-primary">
            (+
            <UAEDirhamIcon className="w-3 h-3" />
            {e.subOption.price})
          </span>
        </Visibility>
      </div>
    );
  };
  const navigate = useNavigate();
  const params = useParams();

  const navegateToProduct = (id: number) => {
    navigate(
      `/${params.domain}/${params.branch_id}/${element.category_id}/${id}`
    );
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4 md:gap-5 p-4 md:p-5 bg-card rounded-xl shadow-md hover:shadow-lg border border-border/50 transition-all duration-300">
      <div className="flex items-start gap-3 md:gap-4 flex-grow min-w-0">
        <img
          src={`${IMG_URl}${element.image}`}
          alt="img"
          className="object-cover rounded-xl w-20 h-20 md:w-24 md:h-24 flex-shrink-0 cursor-pointer hover:scale-105 transition-transform"
          onClick={() => navegateToProduct(element.id)}
        />

        <div className="flex flex-col gap-2 flex-1 min-w-0">
          <h3
            className="text-base md:text-lg font-bold text-foreground cursor-pointer hover:text-primary transition-colors line-clamp-2"
            onClick={() => navegateToProduct(element.id)}
          >
            {element[name]}
          </h3>
          
          <div className="text-xs md:text-sm text-muted-foreground">
            <Iterator
              data={element.option}
              render={(e, i) => renderOptions(e, i)}
            />
          </div>

          <div className="flex items-center text-foreground gap-2 text-sm md:text-base font-semibold">
            <span>{quantity}</span>
            <span>x</span>
            <span>{(calculateTotalPrice() / quantity).toFixed(2)}</span>
            <span>=</span>
            <span className="flex items-center gap-1 text-primary">
              <UAEDirhamIcon className="w-3 h-3 md:w-4 md:h-4" />
              {calculateTotalPrice().toFixed(2)}
            </span>
          </div>
          
          <Visibility visible={!!element.note}>
            <p className="text-xs md:text-sm text-muted-foreground italic">
              {element.note}
            </p>
          </Visibility>
        </div>
      </div>

      <div className="flex items-center gap-3 sm:gap-4 justify-between sm:justify-end">
        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={handleDecrement}
            disabled={quantity <= 1}
            className="bg-primary text-onPrimary px-3 py-1.5 md:px-4 md:py-2 rounded-lg text-lg font-semibold hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          >
            -
          </button>
          <span className="text-base md:text-lg font-semibold text-foreground min-w-[2rem] text-center">
            {quantity}
          </span>
          <button
            onClick={handleIncrement}
            className="bg-primary text-onPrimary px-3 py-1.5 md:px-4 md:py-2 rounded-lg text-lg font-semibold hover:bg-primary/90 transition-all duration-200"
          >
            +
          </button>
        </div>
        <button
          className="flex items-center justify-center p-2.5 md:p-3 bg-destructive/10 hover:bg-destructive/20 text-destructive rounded-lg cursor-pointer transition-all duration-200"
          onClick={() => handleRemoveItem(element)}
        >
          <Trash className="w-5 h-5 md:w-6 md:h-6" />
        </button>
      </div>
    </div>
  );
};

export default CartItem;
